import queryString from "query-string";

import { createApiPdf, createApiV2 } from "./common";

export const getPartialInvoiceAdditionalProducts =
  ({ customerUid, orderUid, params = {} }) =>
  (token) => {
    const queryParams = queryString.stringify(params);
    return createApiV2(
      "GET",
      `customers/${customerUid}/orders/${orderUid}/partial_invoice_additional_products/?${queryParams}`
    )(token);
  };

export const getPartialInvoices =
  ({ customerUid, orderUid, params = {} }) =>
  (token) => {
    const queryParams = queryString.stringify(params);
    return createApiV2(
      "GET",
      `customers/${customerUid}/orders/${orderUid}/partial_invoices/?${queryParams}`
    )(token);
  };

export const getPublicPartialInvoices =
  ({ customerUid, orderUid, params = {} }) =>
  (token) => {
    const queryParams = queryString.stringify(params);
    return createApiV2(
      "GET",
      `customers/${customerUid}/orders/${orderUid}/partial_invoices_public?${queryParams}`
    )(token);
  };

export const postPartialInvoice =
  ({ customerUid, orderUid, ...data }) =>
  (token) =>
    createApiV2(
      "POST",
      `customers/${customerUid}/orders/${orderUid}/partial_invoice_additional_products/`
    )(token, data);

export const postPrintPartialInvoice = (data) => (token) =>
  createApiPdf("POST", `order/print_partial_invoice`, {
    responseType: "arraybuffer",
    headers: { "Content-Type": "multipart/form-data" },
  })(token, data);

export const postEmailPartialInvoice =
  ({ customerUid, orderUid, data } = {}) =>
  (token) =>
    createApiPdf("POST", `customers/${customerUid}/orders/${orderUid}/notify/`, {
      headers: { "Content-Type": "multipart/form-data" },
    })(token, data);

export const postPartialInvoicePdfUrl =
  ({ data }) =>
  (token) =>
    createApiV2("PATCH", `order/partial_invoices/`)(token, data);

export const deletePartialInvoice =
  ({ customerUid, orderUid, partialInvoiceUid }) =>
  (token) =>
    createApiV2(
      "DELETE",
      `customers/${customerUid}/orders/${orderUid}/partial_invoices/${partialInvoiceUid}/`
    )(token);
